// src/views/Error.jsx
import React from "react";
import { useRouteError } from "react-router-dom";
import { Container, Button } from "react-bootstrap";

const ErrorPage = () => {
  const error = useRouteError();
  const status = error?.status || 404;
  const message = error?.statusText || "Page Not Found";

  const goHome = () => {
    // navigate to dashboard root
    window.location.href = "/";
  };

  return (
    <Container
      className="d-flex flex-column align-items-center justify-content-center"
      style={{ minHeight: "80vh" }}
    >
      <h1 style={{ fontSize: "6rem", color: "#ff4d4f" }}>{status}</h1>
      <h2 className="mb-4">{message}</h2>
      <p className="mb-4">
        The page you are looking for does not exist or an unexpected error occurred.
      </p>
      <Button variant="primary" onClick={goHome}>
        Go to Dashboard
      </Button>
    </Container>
  );
};

export default ErrorPage;
